import { axiosInstance } from "@/lib/axios";
import { SendMessagePayload, ChatListResponse, MessageListResponse } from "./types";

export async function getChats(): Promise<ChatListResponse> {
  const { data } = await axiosInstance.get("/direct-message");
  return data;
}

export async function getChatMessages(id: string | number): Promise<MessageListResponse> {
  const { data } = await axiosInstance.get(`/direct-message/${id}`);
  return data;
}

export async function sendMessage(payload: SendMessagePayload): Promise<any> {
  const { data } = await axiosInstance.post("/direct-message", payload);
  return data;
}

export async function markMessageSeen(uuid: string): Promise<any> {
  const { data } = await axiosInstance.get(`/direct/${uuid}/seen`);
  return data;
}
